import { menuList, kategorieList } from '../router'

export default {
  methods: {
    contentUrl(content) {
      const kId = content.categoryId
      let menu = {}
      if (kId) {
        const kategorie = kategorieList.find((k) => k.id == kId)
        let kategorien = []
        if (kategorie && kategorie.ancestry) {
          kategorien = kategorie.ancestry.split('/').reverse()
        }
        kategorien.unshift(kId)
        kategorien.find((kId) => {
          const kategoryMenu = menuList.find(menu => menu.categoryId == kId)
          if (kategoryMenu) {
            menu = kategoryMenu
            return true
          }
        })
      }
      return `/${menu.slug || 'page'}/${content.slug}`
    },
    kategorieUrl(kategorie) {
      const menu = menuList.find(menu => menu.categoryId == kategorie.id) || {}
      if (menu && menu.slug) {
        return `/${menu.slug}`
      } else {
        return `/category/${kategorie.slug || kategorie.id}`
      }
    }
  }
}
